/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:zuijiUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/22 | 富士通Japan株式会社    | 新規作成
//================================================================================
 */

import store from '@/store/store.js';
import { co_post } from '@/common/ajaxUtility.js';

import { ZUIJI_JYUTAKU } from '@/const/const.js';
import { API_ZUIJI_KAIHO_KOSU } from '@/const/route.js';
import { STORE_DATA_GETDATA, STORE_DATA_DELETE_AT } from '@/const/store.js';

/*
 * 残戸数管理処理を実行する
 */
export function co_kosuKaiho() {

	let data = store.getters[STORE_DATA_GETDATA](ZUIJI_JYUTAKU);
	if (data != null) {
		// 残戸数を解放
		let param = {
			'kbBosyu'		: data.bosyuKind.substring(0, 2),
			'kbZyutaku'		: data.jyutakuKind,
			'ymBosyu'		: data.ymBosyu,
			'noMouchiku'	: data.noMouchiku
		};
		co_post(API_ZUIJI_KAIHO_KOSU, param);

		//募集住宅情報（随時募集）の状態管理情報を削除
		store.commit(STORE_DATA_DELETE_AT, ZUIJI_JYUTAKU);
	}

}